import React from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import dateFormat from 'date-fns/format';
import isValid from 'date-fns/isValid';
import parseISO from 'date-fns/parseISO';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import { BlockContainer } from '@atlassian/jira-common-directory-v2/src/components/text-cell/styled';
import { convertISODateFormat } from '@atlassian/jira-compatibility';
import { componentWithFF } from '@atlassian/jira-feature-flagging-utils';
import { FormattedRelativeV2 as FormattedRelative } from '@atlassian/jira-intl';
import { TOOLTIP_DATE_FORMAT } from './constants';
import { getDueDays } from './utils';

const Expiry = ({ value }: { value: string }) => {
	const retentionTillDate = convertISODateFormat(value);
	const dueDays = getDueDays(retentionTillDate);
	const parsedDate = isValid(parseISO(retentionTillDate))
		? parseISO(retentionTillDate)
		: new Date(retentionTillDate);
	return (
		<BlockContainer>
			<Tooltip content={dateFormat(parsedDate, TOOLTIP_DATE_FORMAT)} position="top">
				<FormattedRelative value={retentionTillDate} units="day">
					{(formattedDate) => (
						<CapitalizeContainer>
							<ExpiryDateContainer dueInWeek={dueDays <= 7}>{formattedDate}</ExpiryDateContainer>
						</CapitalizeContainer>
					)}
				</FormattedRelative>
			</Tooltip>
		</BlockContainer>
	);
};

export default Expiry;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const CapitalizeContainer = styled2.div({
	display: 'inline-block',
	'&::first-letter': {
		textTransform: 'uppercase',
	},
});

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ExpiryDateContainerOld = styled.div<{ dueInWeek?: boolean }>`
	color: ${
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(props: any) => (props.dueInWeek ? token('color.text.danger', colors.R400) : 'inherit')
	};
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const ExpiryDateContainerNew = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	color: ({ dueInWeek }: { dueInWeek?: boolean }) =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		dueInWeek ? token('color.text.danger', colors.R400) : 'inherit',
});

const ExpiryDateContainer = componentWithFF(
	'hix-4799-convert-styled-components-to-compiled-and-primitives_bm4r3',
	ExpiryDateContainerNew,
	ExpiryDateContainerOld,
);

ExpiryDateContainer.displayName = 'ExpiryDateContainer';
